var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input input--quantity" },
    [
      _vm.label
        ? _c("label", { staticClass: "u-sr-only" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _c("icon-button", {
        staticClass: "input--quantity__decrement u-icon-primary",
        attrs: {
          label: "Decrease Quantity",
          icon: "minus",
          width: "10px",
          height: "10px",
          disabled: _vm.disableDecrement,
        },
        on: { click: _vm.decrement },
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue",
          },
        ],
        staticClass: "input--quantity__input",
        attrs: {
          type: "text",
          min: _vm.min,
          max: _vm.max,
          placeholder: _vm.placeholder,
          readonly: "",
        },
        domProps: { value: _vm.currentValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.currentValue = $event.target.value
          },
        },
      }),
      _c("icon-button", {
        staticClass: "input--quantity__increment u-icon-primary",
        attrs: {
          label: "Increase Quantity",
          icon: "plus",
          width: "10px",
          height: "10px",
          disabled: _vm.disableIncrement,
        },
        on: { click: _vm.increment },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }